import { useTranslation } from 'next-i18next';
import React, { FC } from 'react';
import PageMeta from 'src/components/organisms/page-meta';
import LaunchpadsTopFilterContainer from 'src/features/common/explore/containers/launchpads-top-filter-container';
import { ExploreContentLayout } from 'src/features/white-labels/ocean/explore/components/explore-content-layout';
import { ExploreHeader } from 'src/features/white-labels/ocean/explore/components/explore-header';
import { LaunchpadsContainer } from 'src/features/white-labels/ocean/explore/containers/launchpads-container';
import { PageLayout } from 'src/ui/white-labels/ocean/layouts/page-layout';

export const LaunchpadsPage: FC = () => {
    const { t } = useTranslation(['pages']);

    return (
        <>
            <PageMeta title={t('launchpads.pageTitle')} />
            <ExploreHeader title={t('launchpads.pageTitle')} />
            <PageLayout>
                <ExploreContentLayout>
                    <ExploreContentLayout.Content>
                        <ExploreContentLayout.ExploreContent>
                            <LaunchpadsTopFilterContainer />
                            <LaunchpadsContainer />
                        </ExploreContentLayout.ExploreContent>
                    </ExploreContentLayout.Content>
                </ExploreContentLayout>
            </PageLayout>
        </>
    );
};